import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Alert, Box, Button, Card, Snackbar, TextField, Typography } from '@mui/material';
import { Formik, Form, useFormik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { PasswordOtpGenerate } from '../network/Auth';
import Page from '../components/Page';

// Styles for the root container
const RootStyle = styled(Page)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100% !important'
});

// Validation schema using Yup
const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email address').required('Email is required')
});

export default function ForgetPassword() {
  const navigate = useNavigate();

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    vertical: 'top',
    horizontal: 'right',
    msg: '',
    variant: 'filled',
    severity: ''
  });

  const vertical = 'bottom';
  const horizontal = 'left';

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  const forgortPasswordFormik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { resetForm }) => {
      const payload = {
        email: values.email
      };
      generateOtp(payload);
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } =
    forgortPasswordFormik;

  // Function to handle OTP generation
  const generateOtp = async (payload) => {
    try {
      const res = await PasswordOtpGenerate(payload);
      if (res) {
        forgortPasswordFormik.setSubmitting(false);
        setAlertMetas({
          ...alertMetas,
          severity: res.data.data?.error ? 'error' : 'success',
          snackBarOpened: true,
          msg: res.data.data?.error ? res.data.data?.error : res?.data?.data?.message
        });
      }
    } catch (error) {
      forgortPasswordFormik.setSubmitting(false);
      setAlertMetas({
        ...alertMetas,
        severity: 'error',
        snackBarOpened: true,
        msg: error?.response?.data?.message
      });
    } finally {
      setTimeout(() => setAlertMetas({ ...alertMetas, snackBarOpened: false, msg: '' }), 4000);
    }
  };

  return (
    <RootStyle title="Forgot Password">
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert variant={alertMetas?.variant} severity={alertMetas?.severity}>
          {alertMetas?.msg}
        </Alert>
      </Snackbar>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          gap: '30px',
          minWidth: { xs: '90%', md: '30%' },
          backgroundColor: '#F8FAFB'
        }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '700',
            lineHeight: '20px',
            textAlign: 'left'
          }}
        >
          Receive OTP via
        </Typography>

        {/* Formik setup */}
        <Formik value={forgortPasswordFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <TextField
              label="Registered Email ID"
              name="email"
              fullWidth
              {...getFieldProps('email')}
              error={Boolean(touched.email && errors.email)}
              helperText={touched.email && errors.email}
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: 2 }}>
              <Button size="medium" variant="outlined" onClick={() => navigate('/login')}>
                Back
              </Button>
              <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting}>
                Send OTP
              </LoadingButton>
            </Box>
          </Form>
        </Formik>
      </Card>
    </RootStyle>
  );
}
